import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=520cf990&"
import script from "./StackedBarChart.vue?vue&type=script&lang=js&"
export * from "./StackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports